const TELEMETRY_URL = 'https://hegxib.me/api/track-click';

export const trackClick = (path) => {
  const payload = { path, timestamp: Date.now(), referrer: document.referrer };

  if (navigator.sendBeacon) {
    navigator.sendBeacon(TELEMETRY_URL, JSON.stringify(payload));
  } else {
    fetch(TELEMETRY_URL, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    }).catch(() => {});
  }
};
